import { render, staticRenderFns } from "./MyWalletGetGasTokenToUse.vue?vue&type=template&id=8c78ac98&scoped=true"
import script from "./MyWalletGetGasTokenToUse.vue?vue&type=script&lang=ts"
export * from "./MyWalletGetGasTokenToUse.vue?vue&type=script&lang=ts"
import style0 from "./MyWalletGetGasTokenToUse.vue?vue&type=style&index=0&id=8c78ac98&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c78ac98",
  null
  
)

export default component.exports